import JobsWrapper from 'components/pages/jobs/JobsWrapper';
import { queryClientConfig } from '@core/configs/queryClientConfig';
import { dehydrate, QueryClient, useQuery  } from 'react-query';
import { JobsPharmaJobs } from 'services/pharmaJobs';

import { setSsrTokens } from 'utils/authentication';
import { getAccessToken } from 'utils/authentication';

import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { NextSeo } from 'next-seo';


const Jobs = () => {
    const seoProps = generateSeoProps({
        title: 'Pharmuni Jobs: 500+ Fresh Pharmaceutical Job Postings updated daily',
        description: 'Browse 500+ pharma-only jobs updated daily. Filter by role and location; see salary, unlock employers and apply in one click with Pharmuni Premium.',
        canonical: 'jobs',
        noIndex: false
    });
    return (
        <>
            <NextSeo {...seoProps} />
            <JobsWrapper />
        </>
    );
}

export async function getServerSideProps(context) {
    const { slug, ...queryParams } = context.query;
    
    setSsrTokens(context);
    const queryClient = new QueryClient(queryClientConfig);
    const { req } = context;
    const userIp = req.headers['x-forwarded-for'];
    const response = await JobsPharmaJobs.GET({ ...queryParams, page: 1, page_size: 10});
    await queryClient.prefetchInfiniteQuery(
        [
            'jobboard-jobs',
            getAccessToken(),
            queryParams?.search_keyword,
            queryParams?.location,
            queryParams?.employment_type,
            queryParams?.favorite
        ],
        ({ pageParam = 1 }) => ({ data: response.data })
    );
    return {
        props: {
            dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),			
        }
    };
}

export default Jobs;

